(function () {
  'use strict';

  function productFor(element) {
    return element && element.closest
      ? element.closest('xo-product[xo-product-information]')
      : null;
  }

  function variantsFor(product) {
    if (product.__variantData) return product.__variantData;
    var data = product.querySelector('[data-product-variants-json]');
    if (!data) return [];
    try {
      product.__variantData = JSON.parse(data.textContent || '[]');
    } catch (error) {
      product.__variantData = [];
    }
    return product.__variantData;
  }

  function optionGroups(product) {
    return Array.prototype.map.call(
      product.querySelectorAll('.xo-product-info-content__variants .xo-product-info-variant'),
      function (group) {
        return {
          root: group,
          fields: Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]')),
          select: group.querySelector('select')
        };
      }
    ).filter(function (group) {
      return group.fields.length || group.select;
    });
  }

  function selectedValues(groups) {
    return groups.map(function (group) {
      var checked = group.fields.find(function (field) { return field.checked; });
      return checked ? checked.value : (group.select ? group.select.value : '');
    });
  }

  function exactVariant(variants, values) {
    return variants.find(function (variant) {
      return variant.options.length === values.length && variant.options.every(function (value, index) {
        return String(value) === String(values[index]);
      });
    });
  }

  function updatePrice(product, variant) {
    var container = product.querySelector(
      'xo-product-will-change[xo-unique-id^="product-price-"] .xo-price__container'
    );
    if (!container) return;

    var price = variant.price_formatted || String(Number(variant.price || 0) / 100);
    var compareAt = variant.compare_at_price_formatted || String(Number(variant.compare_at_price || 0) / 100);

    if (Number(variant.compare_at_price || 0) > Number(variant.price)) {
      container.innerHTML = '<div class="xo-price__sale">' +
        '<span class="xo-price__item">' + price + '</span>' +
        '<span class="xo-price__item xo-price__item--del">' + compareAt + '</span>' +
        '</div>';
    } else {
      container.innerHTML = '<div class="xo-price__regular">' +
        '<span class="xo-price__item">' + price + '</span>' +
        '</div>';
    }
  }

  function updateMedia(product, variant) {
    var mediaId = variant.featured_media && variant.featured_media.id;
    if (!mediaId || !window.xoCarousel) return;

    var slide = product.querySelector('xo-carousel-slide[data-media-id="' + mediaId + '"]:not([xo-cloned])');
    var carousel = slide && slide.closest('xo-carousel');
    if (!carousel) return;

    var slides = Array.prototype.slice.call(
      carousel.querySelectorAll('xo-carousel-slide[data-media-id]:not([xo-cloned])')
    );
    var index = slides.indexOf(slide);
    var name = carousel.getAttribute('xo-name');
    if (name && index >= 0) window.xoCarousel.goTo(name, index);
  }

  function updateAvailability(groups, variants, currentVariant) {
    groups.forEach(function (group, groupIndex) {
      function isAvailable(value) {
        return variants.some(function (variant) {
          return variant.in_stock && variant.options.every(function (option, index) {
            return index === groupIndex
              ? String(option) === String(value)
              : String(option) === String(currentVariant.options[index]);
          });
        });
      }

      group.fields.forEach(function (field) {
        var disabled = !isAvailable(field.value);
        field.disabled = disabled;
        field.toggleAttribute('xo-disabled', disabled);
        field.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });

      if (group.select) {
        Array.prototype.forEach.call(group.select.options, function (option) {
          option.disabled = !isAvailable(option.value);
        });
      }
    });
  }

  function applyVariant(product, groups, variant) {
    groups.forEach(function (group, index) {
      var value = String(variant.options[index]);
      group.fields.forEach(function (field) {
        field.checked = String(field.value) === value;
      });
      if (group.select) group.select.value = value;

      var label = group.root.querySelector('.xo-product-info-variant__name');
      if (label) label.textContent = value;
    });

    product.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variant.id;
      input.disabled = false;
    });

    var sku = product.querySelector('[data-product-sku]');
    if (sku) sku.textContent = variant.sku || '';

    product.removeAttribute('xo-disabled');
    product.removeAttribute('xo-unavailable');
    product.querySelectorAll('xo-product-will-change[xo-unique-id^="product-add-button-"]').forEach(function (item) {
      item.removeAttribute('xo-disabled');
    });
    product.querySelectorAll('xo-cart-add, xo-cart-add button').forEach(function (item) {
      item.removeAttribute('disabled');
      if ('disabled' in item) item.disabled = false;
    });

    updateAvailability(groups, variantsFor(product), variant);
    updatePrice(product, variant);
    updateMedia(product, variant);
  }

  function choose(product, preferredIndex, preferredValue) {
    var groups = optionGroups(product);
    var variants = variantsFor(product);
    var values = selectedValues(groups);
    var variant = exactVariant(variants, values);

    if (!variant || !variant.in_stock) {
      variant = variants.find(function (item) {
        return item.in_stock && String(item.options[preferredIndex]) === String(preferredValue);
      }) || variants.find(function (item) { return item.in_stock; });
    }

    if (variant) applyVariant(product, groups, variant);
  }

  document.addEventListener('change', function (event) {
    var field = event.target instanceof Element
      ? event.target.closest('.xo-product-info-content__variants input, .xo-product-info-content__variants select')
      : null;
    var product = productFor(field);
    if (!field || !product) return;

    event.stopImmediatePropagation();
    var groups = optionGroups(product);
    var index = groups.findIndex(function (group) { return group.root.contains(field); });
    choose(product, index, field.value);
  }, true);

  document.addEventListener('click', function (event) {
    var label = event.target instanceof Element
      ? event.target.closest('.xo-product-info-content__variants label:has(input[xo-disabled])')
      : null;
    var field = label && label.querySelector('input[type="radio"]');
    var product = productFor(field);
    if (!field || !product) return;

    var groups = optionGroups(product);
    var index = groups.findIndex(function (group) { return group.root.contains(field); });
    var hasStock = variantsFor(product).some(function (variant) {
      return variant.in_stock && String(variant.options[index]) === String(field.value);
    });
    if (!hasStock) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    choose(product, index, field.value);
  }, true);

  function initialise(root) {
    root.querySelectorAll('xo-product[xo-product-information]').forEach(function (product) {
      var groups = optionGroups(product);
      var variants = variantsFor(product);
      var current = exactVariant(variants, selectedValues(groups));
      if (!current || !current.in_stock) current = variants.find(function (variant) { return variant.in_stock; });
      if (current) applyVariant(product, groups, current);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
